export const name = 'arrow';

export const Arrow = () => (
  <svg
    viewBox="0 0 10 10"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7.91665V2.08331"
      stroke="currentColor"
      strokeWidth="1.21795"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.08331 4.99998L4.99998 2.08331L7.91665 4.99998"
      stroke="currentColor"
      strokeWidth="1.21795"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
